import React from "react";
import { NavLink } from "react-router-dom";
import Button from "./button";

export default function Footer() {
  const contactEmail = "casey@alvarezbranding.com";
  return (
    <footer className="site-footer">
      <div className="footer-logo" aria-hidden="true" />

      <div className="container footer-inner">
        <div className="footer-grid">
          <div className="footer-col">
            <div className="footer-brand">Alvarez Branding Co.</div>
            <p className="footer-text">
              Branding, websites, and design systems that help growing businesses
              look like leaders.
            </p>
          </div>

          <div className="footer-col">
            <div className="footer-heading">Explore</div>
            <nav aria-label="Footer navigation">
              <ul className="footer-links">
                <li>
                  <NavLink to="/">Home</NavLink>
                </li>
                <li>
                  <NavLink to="/work">Our Work</NavLink>
                </li>
                <li>
                  <NavLink to="/photography">Photography</NavLink>
                </li>
                <li>
                  <NavLink to="/about">About</NavLink>
                </li>
                <li>
                  <NavLink to="/contact">Contact</NavLink>
                </li>
              </ul>
            </nav>
          </div>

          <div className="footer-col">
            <div className="footer-heading">Get in touch</div>
            <div className="footer-text">
              <a className="footer-email" href={`mailto:${contactEmail}`}>
                {contactEmail}
              </a>
            </div>
            <div className="footer-cta">
              <Button to="/contact" type="primary">
                Start a project
              </Button>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="copyright-wrap">
            © {new Date().getFullYear()}, Alvarez Branding Co.
          </div>
        </div>
      </div>
    </footer>
  );
}

